module.exports = __webpack_public_path__ + "img/icon_work_03.8a3344b3.png";